export default {
  shuffleLevels: true,
  shuffleAnswers: true,
  levels: [
    {
      question: 'Lorem ipsum dolor sit amet?',
      answers: [
        {
          content: 'Consectetur',
          value: 1,
        },
        {
          content: 'Adipiscing',
          value: 0,
        },
        {
          content: 'Elit',
          value: 0,
        },
      ],
    },
    {
      question: 'Suspendisse vehicula purus velit?',
      answers: [
        {
          content: 'Pellentesque',
          value: 0,
        },
        {
          content: 'Habitant',
          value: 1,
        },
        {
          content: 'Morbi',
          value: 0,
        },
      ],
    },
  ],
};
